export enum EiImportRecordStructureFieldStatus {

   DIFFERENT_SOURCE,
   DIFFERENT_DEFAULT,
}